import { digiGatewaysOps } from "../api/operations";
import { ROLE } from "../Auth/useRole";
import { entityFactory } from "../hooks/useEntity";
import { defineEntity } from "../api/entity";

const conf = defineEntity({
  ...entityFactory("digi-gateway"),
  endpoint: "digi-gateways",
  operations: digiGatewaysOps,
  roleView: [ROLE.CONTAINER_VIEW, ROLE.CONTAINER_ADMIN],
  roleAdmin: [ROLE.CONTAINER_ADMIN],
  singularName: (t) => t("DigiGateway.singularName", "Digi Gateway"),
  name: (t) => t("DigiGateway.name", "Digi Gateways"),
  syncCustomerFilter: true,
  sorterSeparator: "_",
});

export default conf;
